import { Button, Navbar } from "flowbite-react";

import { HiMenu } from "react-icons/hi";
import { Link } from "react-router-dom";

const DashboarHeader = ({ setIsDrawerOpen }) => {
  return (
    <Navbar fluid className="bg-[#F9FAFB]">
      <div className="w-full p-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center lg:gap-0 gap-4">
            <Button
              size="md"
              outline
              color="light"
              className="outline-none focus:outline-none lg:hidden block cursor-pointer"
              onClick={() => setIsDrawerOpen((prev) => !prev)}
            >
              <HiMenu className="text-[16px]" />
            </Button>
            <Link to="/">
              <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white">
                Interview Detection
              </span>
            </Link>
          </div>
        </div>
      </div>
    </Navbar>
  );
};

export default DashboarHeader;
